var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"section welcome"},[_c('oHeroStatic'),_c('oSectionOffset',[_c('mHowItWorks')],1),_c('mOurServices'),_c('mReviews')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }